import React from 'react';

function RecordStoryCTA({ onClick }) {
  return (
    <div className="sidebar-card record-story-cta">
      <div className="record-header">
        <span className="record-icon">🎤</span>
        <h3 className="record-title">Prefer to talk?</h3>
      </div>
      <p className="record-description">
        Record the story behind these photos
      </p>
      <button className="record-button" onClick={onClick}>
        Record
      </button>
    </div>
  );
}

export default RecordStoryCTA;
